
  import ListParagon, { Filter } from '@/components/ListParagon.vue'
  import dateFormatMixin from '@/mixins/DateFormatMixin.vue'
  import axios, { AxiosError } from "axios";
  import { SnackBarData } from "../Snackbar.vue";
  import { EventBus } from "@/plugins/eventBus";
  import { format } from "date-fns";
  import permissionMixin from "@/mixins/PermissionMixin.vue"
  import Vue, { VueConstructor } from "vue";
  
  export default (Vue as VueConstructor<Vue & InstanceType<typeof permissionMixin>>).extend({
    name: 'PositionList',
    components: {
      ListParagon,
    },
    mixins: [
      dateFormatMixin,
      permissionMixin
    ],
    props: {
      deleted: {
        type: Boolean,
        default: false
      }
    },
    data () {
      return {
        headers: [
          {
            text: this.$vuetify.lang.t("$vuetify.reference"),
            sortable: true,
            value: 'id',
            width: 86
          },
          {
            text: this.$vuetify.lang.t("$vuetify.name"),
            sortable: true,
            value: 'name'
          },
          {
            text: this.$vuetify.lang.t("$vuetify.company"),
            sortable: true,
            value: 'company_name'
          },
          {
            text: this.$vuetify.lang.t("$vuetify.city"),
            sortable: true,
            value: 'postal_city'
          },
          {
            text: this.$vuetify.lang.t("$vuetify.total_associated_workers"),
            sortable: true,
            value: 'total_associated_workers',
            align: 'center',
            width: 100
          },
          {
            text: this.$vuetify.lang.t("$vuetify.total_available_workers"),
            sortable: true,
            value: 'total_available_workers',
            align: 'center',
            width: 114
          },
          {
            text: this.$vuetify.lang.t("$vuetify.total_unavailable_workers"),
            sortable: true,
            value: 'total_unavailable_workers',
            align: 'center',
            width: 123
          },
          {
            text: this.$vuetify.lang.t("$vuetify.total_pending_workers"),
            sortable: true,
            value: 'total_pending_workers',
            align: 'center',
            width: 105
          },
          {
            text: this.$vuetify.lang.t("$vuetify.total_contract_workers"),
            sortable: true,
            value: 'total_contract_workers',
            align: 'center',
            width: 105
          }
        ],
        filters: [
          {
            label: 'searches',
            type: 'text-field'
          },
          {
            text: this.$vuetify.lang.t("$vuetify.reference"),
            label: 'id',
            type: 'text-field'
          },
          {
            label: 'name',
            type: 'text-field'
          },
          {
            label: 'company_name',
            type: 'text-field'
          },
          {
            label: 'city',
            type: 'text-field'
          },
          {
            text: this.$vuetify.lang.t("$vuetify.total_associated_workers"),
            label: 'has_associated_workers',
            type: 'toggle',
            items: [
              {text: this.$vuetify.lang.t("$vuetify.yes"), value: true},
              {text: this.$vuetify.lang.t("$vuetify.no"), value: false}
            ]
          },
          {
            text: this.$vuetify.lang.t("$vuetify.total_contract_workers"),
            label: 'has_contracted_workers',
            type: 'toggle',
            items: [
              {text: this.$vuetify.lang.t("$vuetify.yes"), value: true},
              {text: this.$vuetify.lang.t("$vuetify.no"), value: false}
            ]
          }
        ] as Array<Filter>,
        url: this.deleted ? "/v1/positions?deleted_at=true" : "/v1/positions?deleted_at=false",
        selected: [] as string[]
      }
    },
    methods: {
      redirectToCompany(id: number) {
        this.$router.push(`/company/update/${id}`)
      },
      async deleteSelection(archive: boolean) {
        const ids = this.selected;
        let snackbar: SnackBarData = {message: this.$vuetify.lang.t('$vuetify.empty_selection'), color: "error"}
        if (ids.length > 0) {
          await axios.put(`/v1/positions`, 
            ids.reduce((acc, id) => {
              acc[Number(id)] = {
                deleted_at: archive ? format(new Date(), "yyyy-MM-dd HH:mm:ss") : null
              };
              return acc;
            }, {} as Record<number, {deleted_at: string | null}>)
          )
          .then(() => {
            snackbar = {message: this.$vuetify.lang.t(`$vuetify.position_${archive ? 'archived' : 'reactivated'}_successfully`), color: "success"}
            this.$emit('updateData');
            (this.$refs.list as any).getData();
            this.selected = [];
            (this.$refs.list as any).selected = [];
          })
          .catch((error: AxiosError) => {
            snackbar = {axiosError: error}
          })
        }
        (EventBus as any).$emit('snackbar', snackbar as unknown as SnackBarData)
      },
      createOrderOrMultiposting(bool: boolean) {
        if (this.selected.length === 1) {
          const listComponent = this.$refs.list as any
          const selectedItem = listComponent.items.find((item: any) => item.id === Number(this.selected[0]))

          if (bool) {
            this.$router.push(`/orders/create/${selectedItem.space_id}/${this.selected[0]}`)
          } else {
            this.$router.push(`/multiposting?create=true&position_id=${this.selected[0]}&space_id=${selectedItem.space_id}`)
          }
        } else {
          (EventBus as any).$emit('snackbar', {message: this.$vuetify.lang.t('$vuetify.position_selection_required'), color: "error"})
        }
      }
    }
  })
